import FormControl from '@mui/material/FormControl'
import FormHelperText from '@mui/material/FormHelperText'
import Select, { SelectProps } from '@mui/material/Select'
import { useField } from 'react-final-form'

type MenuSelectFieldProps = Omit<SelectProps<string>, 'name' | 'value' | 'onChange' | 'multiple'> & {
  name: string
}

export function MenuSelectField({ name, required, fullWidth = true, ...props }: MenuSelectFieldProps) {
  const { input, meta } = useField<string>(name)
  const error = meta.error || (!meta.dirtySinceLastSubmit && meta.submitError)
  const showError = Boolean(error && (meta.touched || meta.modified))

  return (
    <FormControl required={required} fullWidth={fullWidth} error={showError}>
      <Select
        {...props}
        name={input.name}
        value={input.value}
        onChange={input.onChange}
        onBlur={input.onBlur}
        onFocus={input.onFocus}
        required={required}
        fullWidth={fullWidth}
        error={showError}
      />
      {showError && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  )
}
